/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Nature_InflammationInputs */

const en_us2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swelling or inflammation`)
};

const pt_br2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inchaço ou inflamação`)
};

const es_419_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinchazón o inflamación`)
};

const pt_pt2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inchaço ou inflamação`)
};

const fr_fr2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gonflement ou inflammation`)
};

const de_de2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellung oder Entzündung`)
};

const it_it2_bodymap_nature_inflammation = /** @type {(inputs: Bodymap_Nature_InflammationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gonfiore o infiammazione`)
};

/**
* | output |
* | --- |
* | "Swelling or inflammation" |
*
* @param {Bodymap_Nature_InflammationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_nature_inflammation = /** @type {((inputs?: Bodymap_Nature_InflammationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Nature_InflammationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_nature_inflammation(inputs)
	if (locale === "es-419") return es_419_bodymap_nature_inflammation(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_nature_inflammation(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_nature_inflammation(inputs)
	if (locale === "de-DE") return de_de2_bodymap_nature_inflammation(inputs)
	if (locale === "it-IT") return it_it2_bodymap_nature_inflammation(inputs)
	return en_us2_bodymap_nature_inflammation(inputs)
});
export { bodymap_nature_inflammation as "bodymap.nature.inflammation" }